<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
       <v-row>
          <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
            <v-alert
              border="top"
              color="red lighten-2"
              dark
              dismissible
              v-model="showError"
            >
              <v-row v-for="(err, key) in errors" :key="key">
                <v-col :class="classPadding">
                  <span>• {{ err }}</span>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>
      <v-row>
         <v-col xs="12" md="4" sm="6" :class="classPadding">
          <v-btn outlined @click.prevent="sync" :loading="isLoading">Sync</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { isNullOrUndefined } from "../../../validation/validation";
import userAccessMixin from "../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/syncPayroll"
export default {
  metaInfo: {
    title: "Sync to payroll",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    title: "Synchronize to Payroll",
    isLoading: false,
    classPadding: "my-0 py-0",
    errors: [],
    showError: false
  }),
  mixins: [userAccessMixin],
  methods: {
    sync() {
      this.isLoading = true
      this.$axios.post(`${API_ENDPOINT}`)
        .then(({ data }) => {
          if(data.length > 0) {
            this.errors = data;
          }else {
            this.$toast.success("Sucessfully synced.")
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message)
        })
        .finally(() => {
          this.isLoading = false;
        })
    }
  },
  created() {
    this.getUserAccessRights("SyncEmp");
  },
  watch: {
    errors(val) {
      if (val.length > 0) this.showError = true;
      else this.showError = false;
    },
  }
}
</script>